module.exports = __webpack_public_path__ + "img/评论@2x.1ff10b8f.png";